<app-form-manager
  formPlugin="core-mapping-spreadsheet-execution-form"
  [params]="params"
  (canceled)="cancel($event)"
  (saveSucceed)="saveSucceed($event)"
  (formEventComplex)="formEventsHandler($event)"
  #form>
</app-form-manager>
